import React, { useEffect } from 'react';
import './styles.css';

/**
 * 模態對話框組件
 * 用於顯示彈出式對話框
 * 
 * @param {Object} props - 組件屬性
 * @param {boolean} props.isOpen - 是否顯示模態框
 * @param {Function} props.onClose - 關閉模態框的回調函數
 * @param {string} props.title - 模態框標題
 * @param {React.ReactNode} props.children - 模態框內容
 * @param {React.ReactNode} props.footer - 模態框頁腳
 * @param {string} props.size - 模態框大小 (small, medium, large)
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element|null} 模態對話框組件
 */
function Modal({
    isOpen,
    onClose,
    title,
    children,
    footer,
    size = 'medium',
    className = '',
}) {
    // 當模態框打開時，禁止背景滾動
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    // 如果模態框未打開，則不渲染
    if (!isOpen) return null;

    // 阻止點擊模態框內容時關閉模態框
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className={`modal-content modal-${size} ${className}`}
                onClick={handleContentClick}
            >
                {title && (
                    <div className="modal-header">
                        <h3 className="modal-title">{title}</h3>
                        <button className="modal-close-button" onClick={onClose}>
                            &times;
                        </button>
                    </div>
                )}

                <div className="modal-body">
                    {children}
                </div>

                {footer && (
                    <div className="modal-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Modal; 